import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Backdrop, Block, Overlay, Portal} from "reakit";
import {Box, Flex} from 'rebass'

import {IconText, PlusIcon, StyledButton} from './styles'
import {FilterOverlay} from "../Search/styles";
import LeaveDetailsCard from './LeaveDetailsCard'


class LeaveDetailsPopup extends Component {
	render() {
		const {details, student, school, hosts, handleApprove, handleDecline, handleSignin, handleSignout, handleResend, handleUndoSignout, firebase, isAdmin, profile, leave_type} = this.props;
		return (
			<div>
				<Overlay.Container>
					{overlay => (
						<Block>
							<Flex  {...overlay} onClick={overlay.show}>
								<Box pl={1}>
									<StyledButton  bg={'yellow'}><IconText><PlusIcon /></IconText></StyledButton>
								</Box>
							</Flex>
							<Backdrop use={[Portal, Overlay.Hide]} {...overlay} />
							<FilterOverlay use={Portal} {...overlay} padding={0} margin={0}>

								<LeaveDetailsCard
									profile={profile}
									firebase={firebase}
									details={details}
									student={student}
									school={school}
									hosts={hosts}
									isAdmin={isAdmin}
									leave_type={leave_type}
									handleApprove={() => {
										handleApprove()
										overlay.hide()
									}}
									closePopup = {() => {
										overlay.hide()
									}}
									handleDecline={() => {
										handleDecline()
										overlay.hide()
									}}
									handleSignin={() => {
										handleSignin()
										overlay.hide()
									}}
									handleSignout={() => {
										handleSignout()
										overlay.hide()
									}}
									handleResend={() => {
										handleResend()
										overlay.hide()
									}}
									handleUndoSignout={() => {
										handleUndoSignout()
										overlay.hide()
									}}
								/>

							</FilterOverlay>
						</Block>
					)}
				</Overlay.Container>


			</div>
		);
	}
}

LeaveDetailsPopup.propTypes = {
	details: PropTypes.object,
	student: PropTypes.object,
	school: PropTypes.object,
	handleApprove: PropTypes.func,
	handleDecline: PropTypes.func,
	handleSignin: PropTypes.func,
	handleSignout: PropTypes.func,
	handleResend: PropTypes.func,
	handleUndoSignout: PropTypes.func,
	hosts: PropTypes.arrayOf(PropTypes.object)
};

LeaveDetailsPopup.defaultProps = {
	handleApprove: () => console.log('popup approving leave'),
	handleDecline: () => console.log('popup declining leave'),
	handleSignin: () => console.log('singing in leave'),
	handleSignout: () => console.log('singing in leave'),
	handleResend: () => console.log('resending leave'),
	handleUndoSignout: () => console.log('undoing signout')
};

export default LeaveDetailsPopup;
